export default __webpack_public_path__ + "static/media/logo_gray.b78224d8.svg";